// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--b0400";
export var btn = "Tabs-module--btn--2f7d6";